import Contact8 from './Contact8'
export default Contact8
